import React, { createContext, useEffect } from "react";
import usePersistTheme from "../hooks/usePersistTheme";

const ThemeContext = createContext({});

const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = usePersistTheme("theme", "light");
  const [sidebarTheme, setSidebarTheme] = usePersistTheme(
    "sidebarTheme",
    "light"
  );
  const [topMenuTheme, setTopMenuTheme] = usePersistTheme(
    "topMenuTheme",
    "light"
  );

  // Portals (dropdowns, modals) mount on document.body — inherit theme tokens from html.
  useEffect(() => {
    document.documentElement.setAttribute("m-data-theme", theme);
  }, [theme]);

  // Remove global.config modification if it's not defined
  try {
    if (global.config) {
      global.config.theme = theme;
    }
  } catch (e) {
    console.warn("global.config is not available");
  }

  return (
    <ThemeContext.Provider
      value={{
        theme,
        setTheme,
        sidebarTheme,
        setSidebarTheme,
        topMenuTheme,
        setTopMenuTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export { ThemeContext };
export default ThemeProvider;
